module.exports = __webpack_public_path__ + "static/media/success_new.017195a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/success_new.png
// module id = 1902
// module chunks = 0 1